import Echo from 'laravel-echo'

import Pusher from "pusher-js";
window.Pusher = Pusher;

export default new Echo({
    broadcaster: 'reverb',
    key: process.env.REVERB_APP_KEY ?? '1702dea665cd7423d8a63fb01c281ed5',
    wsHost: window.location.hostname,
    wsPort: location.port,
    wssPort: location.port,
    forceTLS: false,
    encrypted: true,
    disableStats: true,
    cluster: {},
    enabledTransports: ['ws', 'wss'],
})
